import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styles from '../../styles/components/modules/nutrition-module.module.css';

interface NutritionButton {
  id: string;
  label: string;
  type: 'green' | 'white';
  badge?: number;
  warningCode?: string; // 对应的预警代码
}

interface NutritionModuleProps {
  onButtonClick: (buttonId: string) => void;
  onWarningClick: () => void;
  warningCount?: Record<string, number>;
}

const NutritionModule: React.FC<NutritionModuleProps> = ({
  onButtonClick,
  onWarningClick,
  warningCount
}) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // 处理预警标准按钮点击
  const handleWarningClick = () => {
    const params = new URLSearchParams();
    const deptId = searchParams.get('deptId');
    const identity = searchParams.get('identity');
    const deptName = searchParams.get('deptName');
    
    if (deptId) params.set('deptId', deptId);
    if (identity) params.set('identity', identity);
    if (deptName) params.set('deptName', deptName);
    params.set('module', 'nutrition');
    
    navigate(`/warning-standard?${params.toString()}`);
  };
  // 营养配餐模块按钮配置，根据预警接口文档映射预警代码
  const getButtons = (): NutritionButton[] => {
    const baseButtons: Omit<NutritionButton, 'badge' | 'type'>[] = [
      { id: 'menu-plan', label: '带量食谱公示', warningCode: 'CODE0020001' },
      { id: 'ingredient-manage', label: '每周2次奶豆制品', warningCode: 'CODE0020002' },
      { id: 'nutrition-analysis', label: '正餐食材≥6种', warningCode: 'CODE0020003' },
      { id: 'nutrition-report', label: '科普宣传', warningCode: 'CODE0020004' },
    ];

    return baseButtons.map(button => {
      const alertCount = warningCount?.[button.warningCode!] || 0;
      return {
        ...button,
        type: alertCount > 0 ? 'white' : 'green', // 动态设置type
        badge: alertCount > 0 ? alertCount : undefined
      };
    });
  };

  const buttons = getButtons();

  return (
    <div className={styles.nutritionModule}>
      {/* 标题区域 - 使用bg-title.png */}
      <div className={styles.moduleHeader}>
        <h2 className={styles.moduleTitle}>营养配餐</h2>
      </div>

      {/* 内容区域 - 使用bg-content.png */}
      <div className={styles.contentContainer}>
        {/* 预警标准按钮 */}
        <div className={styles.warningSection}>
          <button
            className={styles.warningButton}
            onClick={handleWarningClick}
          >
            预警标准 &gt;
          </button>
        </div>

        {/* 按钮区域 */}
        <div className={styles.buttonsContainer}>
          {buttons.map((button) => (
            <button
              key={button.id}
              className={`${styles.functionButton} ${styles[button.type]}`}
              onClick={() => {
                const params = new URLSearchParams();
                const deptId = searchParams.get('deptId');
                const identity = searchParams.get('identity');
                const deptName = searchParams.get('deptName');
                
                if (deptId) params.set('deptId', deptId);
                if (identity) params.set('identity', identity);
                if (deptName) params.set('deptName', deptName);
                if (button.warningCode) params.set('warningCode', button.warningCode);
                
                navigate(`/warning-detail?${params.toString()}`);
              }}
            >
              {button.label}
              {button.badge && (
                <span className={styles.badge}>{button.badge}</span>
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NutritionModule;
